module.exports = __webpack_public_path__ + "c2e64c075ea8d5621ec8d0382fc6faa9.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/icons/favicon-32.png
 ** module id = 610
 ** module chunks = 0
 **/